import React, { useEffect, useMemo, useState } from "react"
import { Col, Nav, Row, Tab, } from 'react-bootstrap';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import moment from "moment";
import { useDispatch, useSelector } from "react-redux"
import { BarChart, GaugeChart, LineChart, } from 'echarts/charts';
import { GridComponent, TooltipComponent, TitleComponent, } from 'echarts/components';
import { CanvasRenderer, SVGRenderer, } from 'echarts/renderers';

import navigation from "@/navigation";

import { useAuth } from "@/Hooks/UseAuth";
import useTranslation from "@/Hooks/UseTranslation";
import { useProject } from "@/Hooks/UseProject";

import InterfaceActions from "@/Redux/Actions/InterfaceActions";
import { loadIndicatorsPPCTasksAction, loadIndicatorsPPCWeeklyProgressAction } from "@/Redux/Actions/IndicatorsPPCActions";

import ProjectLayout from "@/Layouts/MainLayout/ProjectLayout";
import ContentHeader from "@/Layouts/MainLayout/components/ContentHeader";
import ContentBody from "@/Layouts/MainLayout/components/ContentBody";

import WeeklyLineCard from "@/Components/Charts/Echarts/WeeklyLineCard/WeeklyLineCard";

echarts.use(
  [TitleComponent, TooltipComponent, GridComponent, BarChart, CanvasRenderer, GaugeChart, LineChart, SVGRenderer]
);

const ProjectIndicatorsPPCPage = (props: any) => {

  const { t } = useTranslation()

  const { project_id, project } = useProject()

  const dispatch = useDispatch()

  const loadProjectStatus = useSelector((state: any) => state.ProjectsReducer.loadRowStatus)
  const indicatorsPPC = useSelector((state: any) => state.IndicatorsPPCReducer)

  const [tab, setTab] = useState('list')
  const [taskTab, setTaskTab] = useState('completed')

  const [promedio, setPromedio] = useState<number>(0)

  const series = useMemo(() => {

    return [
      {
        data: indicatorsPPC.weeklyProgress.result.map((item: any) => item.percentItems),
        name: t('INDICATORS_PPC:WeeklyItemsProgressTooltip'),
        type: 'line',
        smooth: true,
        lineStyle: {
          normal: {
            color: '#ff5721',
            width: 2,
          }
        },
        itemStyle: {
          color: '#ff5721',
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#ff572190'
            },
            {
              offset: 1,
              color: '#fff'
            }
          ])
        },
      },
      {
        data: indicatorsPPC.weeklyProgress.result.map((item: any) => item.percentWorks),
        type: 'line',
        name: t('INDICATORS_PPC:WeeklyWorksProgressTooltip'),
        smooth: true,
        lineStyle: {
          normal: {
            color: '#663299',
            width: 2,
          }
        },
        itemStyle: {
          color: '#663299',
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: '#66329990'
            },
            {
              offset: 1,
              color: '#fff'
            }
          ])
        },
      },
    ]
  }, [indicatorsPPC.weeklyProgress.result])

  const getItemsGaugeData = () => {

    if (!indicatorsPPC.weeklyProgress.result.length) return 0

    const lastWeek = indicatorsPPC.weeklyProgress.result[indicatorsPPC.weeklyProgress.result.length - 1]

    return lastWeek.percentItems?.toFixed(0) || 0
  }

  const getWorksGaugeData = () => {

    if (!indicatorsPPC.weeklyProgress.result.length) return 0

    const lastWeek = indicatorsPPC.weeklyProgress.result[indicatorsPPC.weeklyProgress.result.length - 1]

    return lastWeek.percentWorks?.toFixed(0) || 0
  }

  const optionGaugeItems = {
    series: [
      {
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 25,
            color: [
              [.3, '#fd666d'],
              [0.7, '#37a2da'],
              [1, '#67e0e3'],
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: 'auto'
          }
        },
        axisTick: {
          distance: -30,
          length: 8,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        splitLine: {
          distance: -30,
          length: 30,
          lineStyle: {
            color: '#fff',
            width: 4
          }
        },
        axisLabel: {
          color: 'auto',
          distance: 30,
          fontSize: 10
        },
        detail: {
          valueAnimation: true,
          formatter: '{value} %',
          color: 'auto'
        },
        data: [{ value: getItemsGaugeData() }]
      }
    ]
  };

  const optionGaugeWorks = {
    series: [
      {
        type: 'gauge',
        axisLine: {
          lineStyle: {
            width: 25,
            color: [
              [.3, '#fd666d'],
              [0.7, '#37a2da'],
              [1, '#67e0e3'],
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: 'auto'
          }
        },
        axisTick: {
          distance: -30,
          length: 8,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        splitLine: {
          distance: -30,
          length: 30,
          lineStyle: {
            color: '#fff',
            width: 4
          }
        },
        axisLabel: {
          color: 'auto',
          distance: 30,
          fontSize: 10
        },
        detail: {
          valueAnimation: true,
          formatter: '{value} %',
          color: 'auto'
        },
        data: [{ value: getWorksGaugeData() }]
      }
    ]
  };

  const optionGauge2 = {
    series: [
      {
        type: 'gauge',
        name: 'XXX',
        axisLine: {
          lineStyle: {
            width: 25,
            color: [
              [.3, '#fd666d'],
              [0.7, '#37a2da'],
              [1, '#67e0e3']
            ]
          }
        },
        pointer: {
          itemStyle: {
            color: 'auto'
          }
        },
        axisTick: {
          distance: -30,
          length: 8,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        splitLine: {
          distance: -30,
          length: 30,
          lineStyle: {
            color: '#fff',
            width: 4
          }
        },
        axisLabel: {
          color: 'auto',
          distance: 30,
          fontSize: 10
        },
        detail: {
          valueAnimation: true,
          formatter: '{value}%',
          color: 'auto'
        },
        data: [
          {
            value: promedio
          }
        ]
      }
    ],
  };

  const loadProgressPercentHistory = async () => {

    await dispatch(loadIndicatorsPPCWeeklyProgressAction(project._id))
  }

  const loadTasks = async () => {

    await dispatch(loadIndicatorsPPCTasksAction(project._id, moment().subtract(1, 'w').format('YYYYWW')))
  }

  const getWeekTitle = () => {

    if (!indicatorsPPC.weeklyProgress.result.length) return null

    const weekNumber = indicatorsPPC.weeklyProgress.result[indicatorsPPC.weeklyProgress.result.length - 1]

    const week = moment().week(weekNumber.number)

    return (
      <span>
        {t('INDICATORS_PPC:TitleWeek')} {' '}
        {indicatorsPPC.weeklyProgress.result.length} {' '}
        - {t('INDICATORS_PPC:TitleFrom')} {' '}
        {week.startOf('week').format('DD/MM/YYYY')} {' '}
        {t('INDICATORS_PPC:TitleTo')} {' '}
        {week.endOf('week').format('DD/MM/YYYY')}
      </span>
    )
  }

  useEffect(() => {

    if (loadProjectStatus !== 'loaded') return

    if (indicatorsPPC.weeklyProgress.loadStatus === 'none') {

      loadProgressPercentHistory()
    }

    if (indicatorsPPC.tasks.loadStatus === 'none') {

      loadTasks()
    }

  }, [loadProjectStatus, indicatorsPPC.weeklyProgress.loadStatus, indicatorsPPC.tasks.loadStatus])

  useEffect(() => {

    const projectLoaded = loadProjectStatus == 'loaded'
    const weeklyProgressLoaded = indicatorsPPC.weeklyProgress.loadStatus === 'loaded'
    const tasksLoaded = indicatorsPPC.tasks.loadStatus === 'loaded'

    if (!projectLoaded || !weeklyProgressLoaded || !tasksLoaded) {

      dispatch(InterfaceActions.showLoader())
    } else {

      dispatch(InterfaceActions.hideLoader())
    }
  }, [loadProjectStatus, indicatorsPPC.weeklyProgress.loadStatus, indicatorsPPC.tasks.loadStatus])

  useEffect(() => {

    if (indicatorsPPC.weeklyProgress.loadStatus !== 'loaded') return

    let suma = 0

    indicatorsPPC.weeklyProgress.result.map((item: any) => {

      suma += item.percentItems
    })

    const prom: number = Math.trunc(suma / indicatorsPPC.weeklyProgress.result.length)

    setPromedio(!isNaN(prom) ? prom : 0)
  }, [indicatorsPPC.weeklyProgress.loadStatus, indicatorsPPC.weeklyProgress.result])

  return (
    <ProjectLayout menuName="indicators" subMenuName="ppc">
      <ContentHeader title={t('INDICATORS_PPC:Title')}>
        {/* <div className='ul-widget__head-label flex-grow-1'>
          <h3 className='ul-widget__head-title'>
            {t('INDICATORS_PPC:Title')}{' '}
            | <small style={{ fontSize: '70%' }}>
              {getWeekTitle()}
            </small>
          </h3>
        </div> */}
        <div className="ul-widget__head-nav">
          <Tab.Container>
            <Nav as="ul" className="nav-tabs nav-tabs-line nav-tabs-bold">
              <Nav.Item as="li">
                <Nav.Link active={tab === 'list'} onClick={() => setTab('list')}>
                  <span className="icon-ppc_indicador"></span> {' '}
                  {t('INDICATORS_PPC:ToolbarPPCTab')}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Tab.Container>
        </div>
      </ContentHeader>
      <ContentBody>
        <Row>
          <Col className="mb-4">
            <Tab.Content className="no-padding mb-2">
              <Tab.Pane active={tab === 'list'}>
                <div className="row">
                  <div className='col-md-12'>
                    <WeeklyLineCard
                      title={t('INDICATORS_PPC:WeeklyProgressTitle')}
                      tooltip={{
                        formatter: (items: any) => {

                          return `
                                                                    <div>
                                                                        ${items.map((item: any) => `<span>${item.seriesName}: ${item.value?.toFixed(0) || 0}%</span>`).join('<br />')}
                                                                    </div>
                                                                `
                        }
                      }}
                      series={series}
                      xAxisData={indicatorsPPC.weeklyProgress.result.map((item: any, i: number) => i + 1)}
                      xAxisLabelFormatter="{value}"
                      yAxisLabelFormatter="{value}%"
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className="col-lg-8">
                    <div className="row">
                      <div className='col-lg-8 col-md-6 col-xl-8 mt-4'>
                        <div className='card mb-4'>
                          <div className='card-body'>
                            <div className='card-tittle'>
                              {t('INDICATORS_PPC:PercentageOfPlanCompletedWeek')} {indicatorsPPC.weeklyProgress.result.length}
                            </div>
                            <div className="row">
                              <div className='col-md-6'>
                                <ReactEChartsCore
                                  echarts={echarts}
                                  option={optionGaugeItems}
                                  notMerge={true}
                                  lazyUpdate={true}
                                />
                                <div style={{
                                  marginTop: '-4rem',
                                  fontSize: '.9rem',
                                  fontWeight: 'bold',
                                  textAlign: 'center',
                                }}>
                                  {t('INDICATORS_PPC:Items')}
                                </div>
                              </div>
                              <div className='col-md-6'>
                                <ReactEChartsCore
                                  echarts={echarts}
                                  option={optionGaugeWorks}
                                  notMerge={true}
                                  lazyUpdate={true}
                                />
                                <div style={{
                                  marginTop: '-4rem',
                                  fontSize: '.9rem',
                                  fontWeight: 'bold',
                                  textAlign: 'center',
                                }}>
                                  {t('INDICATORS_PPC:Works')}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-4 col-md-6 col-xl-4 mt-4'>
                        <div className='card mb-4'>
                          <div className='card-body'>
                            <div className='card-tittle'>
                              {t('INDICATORS_PPC:PercentageOfPlanCompletedProject')}
                            </div>
                            <ReactEChartsCore
                              echarts={echarts}
                              option={optionGauge2}
                              notMerge={true}
                              lazyUpdate={true}
                            />
                            <div style={{
                              marginTop: '-4rem',
                              fontSize: '.9rem',
                              fontWeight: 'bold',
                              textAlign: 'center',
                            }}>
                              {t('INDICATORS_PPC:Project')}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='col-lg-4 col-md-6 col-xl-4 mt-4'>
                    <div className='card h-100'>
                      <div className='card-body'>
                        <div className='ul-widget__head'>
                          <div className='ul-widget__head-label'>
                            <h5 className='ul-widget__head-title'>
                              {t('INDICATORS_PPC:TasksWeekTitle')} {indicatorsPPC.weeklyProgress.result.length}
                            </h5>
                          </div>
                          <div className='ul-widget__head-toolbar'>
                            <Tab.Container>
                              <Nav as="ul" className="nav-tabs nav-tabs-line nav-tabs-bold ul-widget-nav-tab-line">
                                <Nav.Item as="li">
                                  <Nav.Link active={taskTab === 'completed'} onClick={() => setTaskTab('completed')}>
                                    {t('INDICATORS_PPC:TasksWeekCompletedTab')}
                                  </Nav.Link>
                                </Nav.Item>
                                <Nav.Item as="li">
                                  <Nav.Link active={taskTab === 'not_completed'} onClick={() => setTaskTab('not_completed')}>
                                    {t('INDICATORS_PPC:TasksWeekNotCompletedTab')}
                                  </Nav.Link>
                                </Nav.Item>
                              </Nav>
                            </Tab.Container>
                          </div>
                        </div>
                        <div className='ul-widget__body'>
                          <Tab.Content>
                            <Tab.Pane active={taskTab === 'completed'}>
                              <div className="ul-widget-1">
                                {indicatorsPPC.tasks.completed.map((taskWeeklyProgress: any, i: number) => (
                                  <div key={i} className='ul-widget4__item ul-widget4__users'>
                                    <div className='ul-widget2__info ul-widget4__users-info'>
                                      <a className='ul-widget2__tittle' href="#">
                                        {taskWeeklyProgress.task.name}
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Tab.Pane>
                            <Tab.Pane active={taskTab === 'not_completed'}>
                              <div className="ul-widget-1">
                                {indicatorsPPC.tasks.notCompleted.map((taskWeeklyProgress: any, i: number) => (
                                  <div key={i} className='ul-widget4__item ul-widget4__users'>
                                    <div className='ul-widget2__info ul-widget4__users-info'>
                                      <a className='ul-widget2__tittle' href="#">
                                        {taskWeeklyProgress.task.name}
                                      </a>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane>

              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </ContentBody>
    </ProjectLayout>
  )
}

export default ProjectIndicatorsPPCPage
